// extracted by mini-css-extract-plugin
export default {"modal":"PS-z","error":"QS-z","disabled":"RS-z","fields":"SS-z","errorMsg":"TS-z","footer":"US-z","formContentWrapper":"VS-z","productImage":"WS-z","overlay":"XS-z"};